import { apiRequest } from '@/utils/api-request';

export interface ItemAccessConfig {
  allowed_by_capitol: boolean;
  enabled_by_org: boolean;
}

export interface OrgNodeAccessConfig {
  orgid: string;
  items: Record<string, ItemAccessConfig>;
  updated_at?: string;
  updated_by?: string;
}

export const getOrgNodeAccessConfig = async (
  orgId: string,
): Promise<OrgNodeAccessConfig> => {
  const response = await apiRequest<OrgNodeAccessConfig>({
    url: `/org-node-access-config/${orgId}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return response?.data || { orgid: orgId, items: {} };
};
